import { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { otherParty } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import { getAge, groupBy, translate, translateNumber } from "../../../helper";
import "./index.css";

const Analytics = (props) => {
  const { lang } = useContext(LangContext);
  let { party } = useParams();
  const [chartView, setChartView] = useState("elected");

  let filteredData = props.data;
  const urlParams = new URLSearchParams(window.location.search);
  let type = urlParams.get("type");
  type = type ? [type] : ["federal"];

  if (party && party !== "all") {
    filteredData = props.data.filter((c) => c.party_code === party || (party === "I" && c.party_code.match(/I+\d/)));
  }
  filteredData = filteredData.filter((c) => type.includes(c.rtype));

  const drawChart = useCallback(
    (chartData) => {
      if (chartView === "elected") {
        chartData = chartData.filter((c) => c.elected);
      }
      const ages = [
        { group: "30", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) < 30).length },
        { group: "31-40", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 30 && (x.birthdate ? getAge(x.birthdate) : x.age) < 40).length },
        { group: "41-50", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 40 && (x.birthdate ? getAge(x.birthdate) : x.age) < 50).length },
        { group: "51-60", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 50 && (x.birthdate ? getAge(x.birthdate) : x.age) < 60).length },
        { group: "61-70", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 60 && (x.birthdate ? getAge(x.birthdate) : x.age) < 70).length },
        { group: "71-80", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 70 && (x.birthdate ? getAge(x.birthdate) : x.age) < 80).length },
        { group: "80", number: chartData.filter((x) => (x.birthdate ? getAge(x.birthdate) : x.age) >= 80).length },
      ];

      const ageData = ages.map((d, i) => {
        let name;
        if (i === 0) {
          name = translate("n_below", lang).replace("[n]", translateNumber(d.group, lang));
        } else if (i === ages.length - 1) {
          name = translate("n_above", lang).replace("[n]", translateNumber(d.group, lang));
        } else {
          name = translateNumber(d.group, lang);
        }

        return {
          name: name,
          p: translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%",
          x: translateNumber(d.number, lang) + " (" + translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%)",
          y: d.number,
          z: translateNumber(d.number, lang),
          // sliced: i === 0 ? true : false,
          selected: true,
        };
      });

      const genders = [
        { group: "female", number: chartData.filter((x) => x.gender === "F").length },
        { group: "male", number: chartData.filter((x) => x.gender === "M").length },
        { group: "other", number: chartData.filter((x) => x.gender === "O").length },
      ];

      const genderData = genders.map((d, i) => {
        return {
          name: translate(d.group, lang),
          p: translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%",
          x: translateNumber(d.number, lang) + " (" + translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%)",
          y: d.number,
          z: translateNumber(d.number, lang),
          // sliced: i === 0 ? true : false,
          selected: true,
        };
      });

      // const ethnicGroups = [];
      // for (let i = 0; i < chartData.length; i++) {
      //   if (!ethnicGroups.find((e) => e.group === filteredData[i].ethnic_group)) {
      //     if (filteredData[i].ethnic_group) ethnicGroups.push({ group: filteredData[i].ethnic_group, number: 1 });
      //   } else {
      //     let eg = ethnicGroups.find((e) => filteredData[i].ethnic_group && e.group === filteredData[i].ethnic_group);
      //     if (eg) eg.number += 1;
      //   }
      // }

      // const ethnicGroupData = ethnicGroups.map((d, i) => {
      //   return {
      //     name: translate(d.group.toLowerCase(), lang),
      //     p: translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%",
      //     x: translateNumber(d.number, lang) + " (" + translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%)",
      //     y: d.number,
      //     z: translateNumber(d.number, lang),
      //     // sliced: i === 0 ? true : false,
      //     selected: true,
      //   };
      // });

      // let academicQualification = [];
      // for (let i = 0; i < chartData.length; i++) {
      //   if (!academicQualification.find((e) => filteredData[i].academic_qualification && e.group === filteredData[i].academic_qualification)) {
      //     academicQualification.push({ group: filteredData[i].academic_qualification, number: 1 });
      //   } else {
      //     let aq = academicQualification.find((e) => filteredData[i].academic_qualification && e.group === filteredData[i].academic_qualification);
      //     if (aq) aq.number += 1;
      //   }
      // }

      // if (academicQualification.length === 1) {
      //   academicQualification = [];
      // }

      // const AQData = academicQualification.map((d, i) => {
      //   return {
      //     name: translate(d.group.toLowerCase(), lang),
      //     p: translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%",
      //     x: translateNumber(d.number, lang) + " (" + translateNumber(((d.number / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%)",
      //     y: d.number,
      //     z: translateNumber(d.number, lang),
      //     // sliced: i === 0 ? true : false,
      //     selected: true,
      //   };
      // });

      let grouped,
        mainParties = [];
      if (party === "all") {
        grouped = groupBy(chartData, (data) => {
          if (data.party_code.match(/I+\d/)) return "I";
          else return data.party_code;
        });

        mainParties = Array.from(grouped).map((a) => ({ key: a[0], value: a[1].length }));
        mainParties = mainParties.sort((a, b) => b.value - a.value);
        let other = mainParties.filter((a, i) => i > 9);
        mainParties = mainParties.filter((a, i) => i < 10);
        other = other.reduce((a, b) => a + b.value, 0);
        mainParties = [...mainParties, { key: "O", value: other }];
      }

      const partyData = mainParties.map((d, i) => {
        return {
          name: props.parties[d.key] ? props.parties[d.key][lang] : otherParty["name_" + lang],
          p: translateNumber(((d.value / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%",
          x: translateNumber(d.value, lang) + " (" + translateNumber(((d.value / parseFloat(chartData.length)) * 100).toFixed(2), lang).toString() + "%)",
          y: d.value,
          z: translateNumber(d.value, lang),
          selected: true,
          color: d.key === "O" ? "#BBBBBB" : null,
        };
      });

      new window.Highcharts.Chart({
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          renderTo: "global-candidate-age-pie",
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          spacingBottom: 10,
          spacingTop: 10,
          spacingLeft: 10,
          spacingRight: 10,
          reflow: true,
        },
        title: {
          text: translate("age", lang),
          // align: "center",
          // verticalAlign: "middle",
          // y: 10,
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x}</b><br/>',
        },
        legend: {
          itemStyle: {
            fontSize: "14px",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.p}",
              style: {
                fontSize: "15px",
              },
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: translate("number", lang),
            data: ageData,
          },
        ],
        credits: {
          enabled: false,
        },
      });

      new window.Highcharts.Chart({
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          renderTo: "global-candidate-gender-pie",
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          spacingBottom: 10,
          spacingTop: 10,
          spacingLeft: 10,
          spacingRight: 10,
          reflow: true,
        },
        title: {
          text: translate("gender", lang),
          // align: "center",
          // verticalAlign: "middle",
          // y: 10,
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x}</b><br/>',
        },
        legend: {
          itemStyle: {
            fontSize: "14px",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.p}",
              style: {
                fontSize: "15px",
              },
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: translate("number", lang),
            data: genderData,
          },
        ],
        credits: {
          enabled: false,
        },
      });

      // new window.Highcharts.Chart({
      //   chart: {
      //     type: "pie",
      //     options3d: {
      //       enabled: true,
      //       alpha: 45,
      //       beta: 0,
      //     },
      //     renderTo: "global-candidate-ethnic-pie",
      //     plotBackgroundColor: null,
      //     plotBorderWidth: 0,
      //     plotShadow: false,
      //     spacingBottom: 10,
      //     spacingTop: 10,
      //     spacingLeft: 10,
      //     spacingRight: 10,
      //     reflow: true,
      //   },
      //   title: {
      //     text: translate("ethnic_group", lang),
      //     // align: "center",
      //     // verticalAlign: "middle",
      //     // y: 10,
      //   },
      //   tooltip: {
      //     headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
      //     pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x}</b><br/>',
      //   },
      //   plotOptions: {
      //     pie: {
      //       allowPointSelect: true,
      //       cursor: "pointer",
      //       depth: 35,
      //       dataLabels: {
      //         enabled: true,
      //         format: "{point.name}: {point.p}",
      //       },
      //       showInLegend: true,
      //     },
      //   },
      //   series: [
      //     {
      //       type: "pie",
      //       name: translate("number", lang),
      //       data: ethnicGroupData,
      //     },
      //   ],
      //   credits: {
      //     enabled: false,
      //   },
      // });

      // new window.Highcharts.Chart({
      //   chart: {
      //     type: "pie",
      //     options3d: {
      //       enabled: true,
      //       alpha: 45,
      //       beta: 0,
      //     },
      //     renderTo: "global-candidate-aq-pie",
      //     plotBackgroundColor: null,
      //     plotBorderWidth: 0,
      //     plotShadow: false,
      //     spacingBottom: 10,
      //     spacingTop: 10,
      //     spacingLeft: 10,
      //     spacingRight: 10,
      //     reflow: true,
      //   },
      //   title: {
      //     text: translate("academic_qualification", lang),
      //     // align: "center",
      //     // verticalAlign: "middle",
      //     // y: 10,
      //   },
      //   tooltip: {
      //     headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
      //     pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x}</b><br/>',
      //   },
      //   plotOptions: {
      //     pie: {
      //       allowPointSelect: true,
      //       cursor: "pointer",
      //       depth: 35,
      //       dataLabels: {
      //         enabled: true,
      //         format: "{point.name}: {point.p}",
      //       },
      //       showInLegend: true,
      //     },
      //   },
      //   series: [
      //     {
      //       type: "pie",
      //       name: translate("number", lang),
      //       data: AQData,
      //     },
      //   ],
      //   credits: {
      //     enabled: false,
      //   },
      // });

      if (party === "all") {
        new window.Highcharts.Chart({
          chart: {
            type: "pie",
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0,
            },
            renderTo: "global-candidate-party-pie",
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            spacingBottom: 10,
            spacingTop: 10,
            spacingLeft: 10,
            spacingRight: 10,
            reflow: true,
          },
          title: {
            text: translate("parties", lang),
            // align: "center",
            // verticalAlign: "middle",
            // y: 10,
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x}</b><br/>',
          },
          legend: {
            itemStyle: {
              fontSize: "14px",
            },
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: "pointer",
              depth: 35,
              dataLabels: {
                enabled: true,
                format: "{point.name}: {point.p}",
                style: {
                  fontSize: "15px",
                },
              },
              showInLegend: true,
            },
          },
          series: [
            {
              type: "pie",
              name: translate("number", lang),
              data: partyData,
            },
          ],
          credits: {
            enabled: false,
          },
        });
      }
    },
    [lang, party, props.parties, chartView]
  );

  useEffect(() => {
    const chartData = JSON.parse(JSON.stringify(filteredData));
    drawChart(chartData);
  }, [filteredData, drawChart, props]);

  const handleChangeType = (el) => {
    setChartView(el.target.value);
    filteredData = props.data;
    const chartData = JSON.parse(JSON.stringify(filteredData));
    drawChart(chartData);
  };

  return (
    <section className="sh-candidate-analytics-section">
      <div className="container">
        <h3 className="my-4">
          {translate("candidate_list", lang)} :&nbsp; {party === "all" ? translate("all_parties", lang) : props.parties[party] ? props.parties[party][lang] : ""}
        </h3>
        <div className="row">
          <div className="col-md-12">
            <div className="container-fluid card sh-card-summary">
              <div className="row">
                <div className="sh-radio-choice mb-3">
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="view1" id="analytics-elected" value="elected" checked={chartView === "elected"} onChange={handleChangeType} />
                    <label className="form-check-label" htmlFor="elected">
                      {translate("elected", lang) + " " + translate("candidates", lang)}
                    </label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" name="view2" id="analytics-all" value="all" checked={chartView === "all"} onChange={handleChangeType} />
                    <label className="form-check-label" htmlFor="all">
                      {translate("all_candidates", lang)}
                    </label>
                  </div>
                </div>
              </div>

              <div className="row mb-5">
                <div className="col-md-6 col-sm-12 sh-mb-5">
                  <div className="row">
                    <div className="col-md-12">
                      <div id="global-candidate-age-pie" className="sh-chart-analytics" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div id="global-candidate-gender-pie" className="sh-chart-analytics" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-md-6 col-sm-12 sh-mb-5">
                  <div className="row">
                    <div className="col-md-12">
                      <div id="global-candidate-ethnic-pie" className="sh-chart-analytics" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="row">
                    <div className="col-md-12">
                      <div id="global-candidate-aq-pie" className="sh-chart-analytics" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                </div>
              </div> */}
              {party === "all" && (
                <div className="row">
                  <div className="col-md-12">
                    <div id="global-candidate-party-pie" className="sh-chart-analytics" style={{ width: "100%" }}></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Analytics;
